import { withInstall } from '@vuesax-alpha/utils'
import Switch from './src/switch.vue'

export const VsSwitch = withInstall(Switch)
export default VsSwitch

export * from './src/switch'
